import env from "@/env.mjs";
import { useAuth } from "@/lib/centra/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { ofetch } from "ofetch";
import { IOrder } from "./order";

const apiUrl = env.NEXT_PUBLIC_CENTRA_CHECKOUT;

interface OrderResponse {
  token: string;
  orders: IOrder[];

  ordersPaging: {
    from: number;
    size: number;
    totalSize: number;
  };
}

const fetchOrders = async ({
  token,
  size,
  from,
}: {
  token: string;
  size?: number;
  from?: number;
}) => {
  return ofetch<OrderResponse>(`${apiUrl}/orders`, {
    method: "POST",
    headers: {
      "API-token": token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      size,
      from,
    }),
  });
};

export type OrderPaging = {
  from?: number;
  size?: number;
};

export const useOrders = ({ from, size }: OrderPaging = {}) => {
  const { token } = useAuth();

  return useQuery({
    queryKey: ["orders", token, from, size],
    queryFn: async () => await fetchOrders({ token: token!, size, from }),
    enabled: !!token,
  });
};
